import { InjectionToken } from '@angular/core';
import { AgentConfigOptions } from '@elastic/apm-rum';
import { INHAAuthConfiguration } from 'nha-login';
import { Environments } from '../../enums/environment.enum';
import { IOneSignalConfig } from './ionesignal-config.interface';

export interface IAppSettings {
	env: Environments;

	web: {
		[key: string]: string;
		application: string;
		schoolSites: string;
		collegeReadiness: string;
	};
	api: {
		[key: string]: string;
		scholar: string;
		application: string;
	};

	calendarPublicServiceUrl: string;
	calendarPrivateServiceUrl: string;
	calendarPDFServiceUrl: string;
	calendarCRMServiceUrl: string;
	calendarCRMEventRsvpUrl: string;
	cmsBaseUrl: string;
	crmWaitlistUrl: string;

	monitoring: AgentConfigOptions;

	parentOktaConfig: INHAAuthConfiguration;
	studentOktaConfig: INHAAuthConfiguration;

	analytics: {
		enabled: boolean;
		streamID: string;
	};
	showApplicationSchoolPicker: boolean;
	schoolConnectURL: string;
	hotjarFeedbackURL: string;
	trainingVideoLink: string;
	forceUpdateEnabled: string;
	parentPortalNotificationManagement: string;
	parentPortalMinimumAppVersion: string;
	appStoreLinks: {
		android: string;
		ios: string;
	};
	scholarWebRootUrl: string;
	oneSignal: IOneSignalConfig;
}

export const APP_CONFIG = new InjectionToken<IAppSettings>('APP_CONFIG');
